module.exports = __webpack_public_path__ + "static/fund-b01d2448949ffe441b883b95fe35e58f.jpg";